module.exports = __webpack_public_path__ + "img/warning-icon.fbd33943.svg";